import { userAddress } from "../config";

const base_user_url = "/api/v1/users";

const full_base_path = userAddress + base_user_url;

export const getStoryProgress = (token) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow"
    }

    return fetch(full_base_path + "/storyprogress", requestOptions)
    .then(response => {
        if (response.ok) {
            return response.json();
        } else if (response.status === 403){
            return([]);
        } else {
            throw new Error("Story progress could not be fetched.");
        }
    })
}

export const addStoryProgress = (token, storyId, finishedPath, bestPath) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    if (token) {
        myHeaders.append("Authorization", "Bearer " + token);
    }

    const raw = JSON.stringify({
        "storyId": storyId,
        "pathFinished": finishedPath,
        "bestPath": bestPath
    });
    
    const requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    return fetch(full_base_path + "/storyprogress", requestOptions)
    .then(response => {
        if (response.ok) {
            return response.json();
        } else if (response.status === 403){
            return([]);
        }  else {
            throw new Error("Story progress could not be updated.");
        }
    })
    .catch(error => {
        console.log('error', error)
        return([]);
    });
}

export const getQuizProgress = (token, userId) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow"
    }

    return fetch(full_base_path + "/quizprogress/" + userId, requestOptions)
    .then(response => {
        if (response.ok) {
            return response.json();
        } else if (response.status === 403){
            return([]);
        }  else {
            throw new Error("Quiz progress could not be fetched.");
        }
    })
}

export const addQuizProgress = (token, quizpartId, userId) => {
    const myHeaders = new Headers();
    if (token) {
        myHeaders.append("Authorization", "Bearer " + token);
    }

    const requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(full_base_path + "/quizprogress/" + userId + "/" + quizpartId, requestOptions)
    .then(response => {
        if (response.ok) {
            return response.json();
        } else if (response.status === 403){
            return([]);
        }  else {
            throw new Error("Quiz progress could not be updated.");
        }
    })
    .catch(error => {
        console.log('error', error)
        return([]);
    });
}

export const getVideoProgress = (token) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow"
    }

    return fetch(full_base_path + "/videoprogress", requestOptions)
    .then(response => {
        if (response.ok) {
            return response.json();
        } else if (response.status === 403){
            return([]);
        }  else {
            throw new Error("Video progress could not be fetched.");
        }
    })
}

export const finishVideo = (token, videoId) => {
    const myHeaders = new Headers();
    if (token) {
        myHeaders.append("Authorization", "Bearer " + token);
    }

    const requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(full_base_path + "/videoprogress/" + videoId + "/finish", requestOptions)
    .then(response => {
        if (response.ok) {
            return response.json();
        } else if (response.status === 403){
            return([]);
        }  else {
            throw new Error("Video progress could not be updated.");
        }
    })
    .catch(error => {
        console.log('error', error)
        return([]);
    });
}

export const unlockVideo = (token, videoId) => {
    const myHeaders = new Headers();
    if (token) {
        myHeaders.append("Authorization", "Bearer " + token);
    }

    const requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(full_base_path + "/videoprogress/" + videoId + "/unlock", requestOptions)
    .then(response => {
        if (response.ok) {
            return response.json();
        } else if (response.status === 403){
            return([]);
        }  else {
            throw new Error("Video progress could not be updated.");
        }
    })
    .catch(error => {
        console.log('error', error)
        return([]);
    });
}

export const questionStats = (token, questionId, isCorrect) => {
    const myHeaders = new Headers();
    if (token) {
        myHeaders.append("Authorization", "Bearer " + token);
    }
    myHeaders.append("Content-Type", "application/json");


    const raw = JSON.stringify({
        "questionId": questionId,
        "correct": isCorrect
    });

    const requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    return fetch(full_base_path + "/stats/question", requestOptions);
}